import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Dialog, type DialogControlProps } from '@root/shared/ui-kit'
import { DialogHeader } from '@root/shared/ui-kit/dialog/header'

import { WalletDistribute } from './wallet-distribute'

import type { DistributeFundsModel } from '../atoms'
import type { WalletModel } from '@root/entities/wallet'

type Props = {
  model?: DistributeFundsModel
  sourceWallet?: WalletModel
} & DialogControlProps

export const WalletDistributeDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  model,
  sourceWallet,
}) => {
  const { t } = useTranslation()
  return (
    <Root
      variant="bordered"
      describedBy={t('wallet.funds-management')}
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogHeader title={t('wallet.funds-management')} />
      <WalletDistribute
        model={model}
        sourceWallet={sourceWallet}
        onClose={() => {
          onOpenChange?.(false)
        }}
      />
    </Root>
  )
}

const Root = styled(Dialog)``
